import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PayPeriodModel } from 'projects/rms/app/api/models/pay-period-model';

@Component({
  selector: 'pay-period-edit',
  templateUrl: './pay-period-edit.component.html',
  styleUrls: ['./pay-period-edit.component.css']
})
export class PayPeriodEditComponent {
  @Input()
  set model(model: PayPeriodModel) {
    this.payperiod = Object.assign({}, model);
    this.formGroup.patchValue({
      endDate: model.endDate ? new Date(model.endDate) : "",
      startDate: model.startDate ? new Date(model.startDate) : "",
      id: model.id ? model.id : "",
      fiscalYear: model.fiscalYear,
      periodNumber: model.periodNumber,
      periodQuarter: model.periodQuarter,
      periodYear: model.periodYear,
      active: model.active
    });
  }
  @Output() save = new EventEmitter<PayPeriodModel>();
  @Output() cancel = new EventEmitter<boolean>();
  @Output() edit = new EventEmitter<PayPeriodModel>();

  modelError = "";
  formGroup: FormGroup;
  payperiod: PayPeriodModel = {};

  constructor(private _formBuilder: FormBuilder) {
    this.formGroup = this._formBuilder.group({
      id: null,
      endDate: ["", Validators.required],
      startDate: ["", Validators.required],
      fiscalYear: ["", Validators.required],
      periodNumber: ["", Validators.required],
      periodQuarter: ["", Validators.required],
      periodYear: ["", Validators.required],
      active: true
    });
  }

  onStartDateChange() {
    let startDate = new Date(this.formGroup.get("startDate").value);
    let endDate = new Date(this.formGroup.get("endDate").value);
    if (startDate.getTime() >= endDate.getTime()) {
      this.formGroup.get("endDate").setValue(null);
    }
  }

  onEndDateChange() {
    if (!this.formGroup.get("endDate").value) return;	//because a null date gets interpreted as 0 seconds since unix epoch or whatever, erasing it throws off the logic
    let startDate = new Date(this.formGroup.get("startDate").value);
    let endDate = new Date(this.formGroup.get("endDate").value);
    if (startDate.getTime() >= endDate.getTime()) {
      this.formGroup.get("startDate").setValue(null);
    }
  }

  onCancelClick() {
    this.cancel.emit(false);
  }

  onSaveClick() {
    if (this.formGroup.invalid) {
      Object.keys(this.formGroup.controls).forEach(formKey => {
        this.formGroup.controls[formKey].markAsDirty();
      });
    }
    else {
      this.payperiod.endDate = this.formGroup.get("endDate").value;
      this.payperiod.startDate = this.formGroup.get("startDate").value;
      this.payperiod.periodYear = this.formGroup.get("periodYear").value;
      this.payperiod.periodQuarter = this.formGroup.get("periodQuarter").value;
      this.payperiod.fiscalYear = this.formGroup.get("fiscalYear").value;
      this.payperiod.active = this.formGroup.get("active").value;
      this.payperiod.periodNumber = this.formGroup.get("periodNumber").value;

      if (this.payperiod.id) {
        this.edit.emit(this.payperiod);
      } else {
        this.save.emit(this.payperiod);
      }
    }
  }
}
